/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".short-string{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.user-top-menu{width:350px}.circle-img{border-radius:50%;background-color:#eee;margin:0 4px}"];
export { styles as styles };
